import { useTheme, styled, Box } from '@mui/material';

import { JsonViewer } from '@/components/shared/jsonViewer';

import { QueryResultsInProgress } from './QueryResultsTable';
import QueryResultsFooter from './queryResultsFooter';

interface QueryResultsTreeProps {
  queryId?: string;
  data?: string[][];
  headerColumns?: string[];
  executionTime?: number;
  loading: boolean;
  resultsLink?: string | null;
}

const DBResultsWrapper = styled('div')(function ({ theme }) {
  const isDarkMode = theme.palette.mode === 'dark';
  return {
    display: 'block',
    whiteSpace: 'nowrap',
    height: 'calc(100% - 50px)',
    overflow: 'auto',
    borderRadius: '16px 16px 0 0',
    backgroundColor: isDarkMode ? '#505050' : '#EDEDED',
  };
});

export default function QueryResultsTree(props: QueryResultsTreeProps) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        height: '100%',
        backgroundColor: isDarkMode ? '#505050' : '#EDEDED',
        borderRadius: '16px',
      }}
    >
      {!props.loading && props.data && (
        <>
          <DBResultsWrapper>
            <JsonViewer
              data={(props?.data ?? []).map((record) =>
                Object.fromEntries(
                  props.headerColumns?.map((col, i) => [col, record[i]]) ?? []
                )
              )}
            />
          </DBResultsWrapper>
          <QueryResultsFooter {...props} />
        </>
      )}
      {props.loading && <QueryResultsInProgress queryId={props.queryId} />}
    </Box>
  );
}
